import { cloneDeep, clone, sortBy, isEmpty } from 'lodash';
// import uuid from 'uuid/v4';
import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { DV_DEFAULT_VALUE } from '../constants';
import {
  CAC_LEFT_PANEL_VIEW_LABEL, 
  CAC_MAXIMUM_PROJECT_COUNT,
  CLUSTER_ERROR_MESSAGE,
  CORR_ERROR_MESSAGE,
} from '../components/corrCluster/CacConstants';
import {
  createNewProjectList,
  getProjectDetailsFromSavedProjects,
  NEW_PROJECT_MINIMUM_DATA,
} from '../util/cacUtils';
import * as CrosstabUtils from '../util/CrosstabUtils';

export default (state = initialState.correspondenceCluster, action) => {
  switch (action.type) {
    case types.CREATE_CAC_NEW_PROJECT: {
      const { newProjects, projectId, activeProjectId } = createNewProjectList(
        [action],
        state.projectId,
        state.activeProjectId
      );
      return {
        ...state,
        projects: [...state.projects, ...newProjects],
        projectId,
        activeProjectId,
      };
    }

    case types.ADD_CAC_PROJECT_DETAILS: {
      const reduxState = cloneDeep(state.projects);
      const activeProject = state.activeProjectId;
      if (action.payload.status === 400 || action.payload.status === 500) {
        const projects = reduxState.map(project => {
          if (activeProject === project.projectId) {
            project.corrResponse = {};
            project.corrResponse.errMsg = CORR_ERROR_MESSAGE;
          }
          return project;
        });
        return {
          ...state,
          projects: [...projects],
        };
      }

      const projects = reduxState.map(project => {
        if (activeProject === project.projectId) {
          project.corrResponse = action.payload;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CAC_ADD_PROJECT_CONTOUR_MAP: {
      const reduxState = cloneDeep(state.projects);
      const activeProject = state.activeProjectId;
      if (action.payload.status === 400 || action.payload.status === 500) {
        const projects = reduxState.map(project => {
          if (activeProject === project.projectId) {
            project.contourMap = {};
            // project.contourmap.errMsg = CORR_ERROR_MESSAGE;
          }
          return project;
        });
        return {
          ...state,
          projects: [...projects],
        };
      }

      const projects = reduxState.map(project => {
        if (activeProject === project.projectId) {
          project.contourMap = action.payload;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }    

    case types.CAC_HANDLE_VIEW_SWITCH: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.leftPanel = action.activeView;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.SET_CAC_PROJECT_TO_ACTIVE: {
      return {
        ...state,
        activeProjectId: action.selectedProjectId,
      };
    }

    case types.TOGGLE_COLLAPSIBLE_DROPDOWN: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project[action.keyType] = !project[action.keyType];
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_SHOW_CONTRIBUITON_SCORES: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.mapOptions.showContributionScores =
            action.showContributionScores;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_SET_IS_CENTER_CHART: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.mapOptions.isCenterChart = action.centerChart;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_SET_SHOW_PASSIVES: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.mapOptions.showPassive = action.showPassive;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_SET_IS_AXIS_VISIBLE: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.mapOptions.isAxisVisible = action.isAxisVisible;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_SET_ARE_ROWS_VISIBLE: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.mapOptions.areRowsVisible = action.areRowsVisible;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_SET_ARE_COLS_VISIBLE: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.mapOptions.areColsVisible = action.areColsVisible;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_SHOW_COL_LONG_NAMES: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.mapOptions.showColLongNames = action.showColLongNames;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_SHOW_ROW_LONG_NAMES: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.mapOptions.showRowLongNames = action.showRowLongNames;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_SHOW_PASSIVE_LONG_NAMES: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.mapOptions.showPassiveLongNames = action.showPassiveLongNames;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_CHART_VIEW: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.chartView = action.chartView;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_CLEAR_LABEL_POSITIONS: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.mapOptions.frontNodeLabelPositions = [];
          project.mapOptions.frontNodeLabelPositionsCentered = [];
          project.mapOptions.topNodeLabelPositions = [];
          project.mapOptions.topNodeLabelPositionsCentered = [];
          project.mapOptions.sideNodeLabelPositions = [];
          project.mapOptions.sideNodeLabelPositionsCentered = [];
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_NODE_LABEL_POSITIONS: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          switch (action.cView) {
            default:
              break;
            case 'front': {
              if (action.isCenterChart !== true) {
                project.mapOptions.frontNodeLabelPositions = clone(
                  action.nodeLabelPositions
                );
              } else {
                project.mapOptions.frontNodeLabelPositionsCentered = clone(
                  action.nodeLabelPositions
                );
              }
              break;
            }
            case 'top': {
              if (action.isCenterChart !== true) {
                project.mapOptions.topNodeLabelPositions = clone(
                  action.nodeLabelPositions
                );
              } else {
                project.mapOptions.topNodeLabelPositionsCentered = clone(
                  action.nodeLabelPositions
                );
              }
              break;
            }
            case 'side': {
              if (action.isCenterChart !== true) {
                project.mapOptions.sideNodeLabelPositions = clone(
                  action.nodeLabelPositions
                );
              } else {
                project.mapOptions.sideNodeLabelPositionsCentered = clone(
                  action.nodeLabelPositions
                );
              }
              break;
            }
          }
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_UPDATE_NODES: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          //  project.isProjectSaved = false;
          project.updateNodes = action.updateNodes;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_NODE_COLORS: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          project.nodeColors = action.nodeColors;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_IS_PROJECT_SAVED: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = action.isProjectSaved;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.ADD_TO_PASSIVE: {
      const reduxState = cloneDeep(state.projects);
      const indexVal = action.index;
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          if (action.gridType === 'col') {
            project.columns[indexVal].isPassive = !project.columns[indexVal]
              .isPassive;
          }
          if (action.gridType === 'row') {
            project.rows[indexVal].isPassive = !project.rows[indexVal]
              .isPassive;
          }
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.EDIT_PROJECT_TAB_NAME: {
      const { updatedObjectProps, activeProjectId } = action;
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === activeProjectId) {
          project.title = updatedObjectProps.newProjectName;
          project.isProjectSaved = false;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CAC_EDIT_ROW_COL_TITLE: {
      const { newTitle, nodeType, nodeIndex } = action;

      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          // find the node and update it's title
          switch (nodeType) {
            default: break;
            case 'row': {
              const row = project.rows[nodeIndex];
              row.title = newTitle;
              const cmRow = project.corrResponse.cm.rowPoints[nodeIndex];
              cmRow.label = newTitle;
              break;
            }
            case 'col': {
              const col = project.columns[nodeIndex];
              col.title = newTitle;
              const cmCol = project.corrResponse.cm.colPoints[nodeIndex];
              cmCol.label = newTitle;
              try{
                project.clusterResponse.targets[nodeIndex] = newTitle;
              }catch(e){
                // empty
              }
              break;
            }
          }

          project.isProjectSaved = false;
        }
        return project;
      });

      return { ...state, projects: [...projects] };
    }

    case types.CAC_RESTORE_ROW_COL_TITLE: {
      const { nodeType, nodeIndex } = action;

      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          // find the node and update it's title
          switch (nodeType) {
            default: break;
            case 'row': {
              const row = project.rows[nodeIndex];
              row.title = row.originalTitle;
              const cmRow = project.corrResponse.cm.rowPoints[nodeIndex];
              cmRow.label = row.originalTitle;
              break;
            }
            case 'col': {
              const col = project.columns[nodeIndex];
              col.title = col.originalTitle;
              const cmCol = project.corrResponse.cm.colPoints[nodeIndex];
              cmCol.label = col.originalTitle;
              try{
                project.clusterResponse.targets[nodeIndex] = col.originalTitle;
              }catch(e){
                // empty
              }

             
              break;
            }
          }

          project.isProjectSaved = false;
        }
        return project;
      });



      return { ...state, projects: [...projects] };
    }


    case types.UPDATE_NEW_PROJECT_PID: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.payload.activeProjectId) {
          project.pid = action.payload.pid;
          project.originalTitle = action.payload.originalTitle;
          project.isProjectSaved = true;
          if (action.payload.title) {
            if (project.tempTitle) {
              delete project.tempTitle;
            }
            project.title = action.payload.title;
          }
        }
        return project;
      });
      return { ...state, projects: [...projects] };
    }

    case types.UPDATE_TEMP_PROJECT_TITLE: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.payload.activeProjectId) {
          project.tempTitle = action.payload.title;
        }
        return project;
      });
      return { ...state, projects: [...projects] };
    }

    case types.CREATE_CAC_NEW_PROJECT_FROM_SAVE: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.title = project.originalTitle
            ? project.originalTitle
            : project.title;
        }
        return project;
      });
      const { newProjects, projectId, activeProjectId } = createNewProjectList(
        [action],
        state.projectId,
        state.activeProjectId
      );
      return {
        ...state,
        projects: [...projects, ...newProjects],
        projectId,
        activeProjectId,
      };
    }

    case types.REMOVE_ACTIVE_PROJECT_TEMP_TITLE: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          if (project.tempTitle) {
            delete project.tempTitle;
          }
        }
        return project;
      });
      return { ...state, projects: [...projects] };
    }

    case types.ADD_OPENED_PROJECTS_DATA: {
      /**
       * All the logic to get merge the data from saved file to respective data in project
       * should be done only in getProjectDetailsFromSavedProject method.
       * In future if the requiremen is ability to select multiple files and open them.
       * getProjectDetailsFromSavedProject will handle it. openedList can handle single
       * file or multiple files
       */
      const openedList = getProjectDetailsFromSavedProjects(action.payload);
      let tempActiveProject;
      if (action.selectedProjectId) {
        tempActiveProject = action.selectedProjectId;
      } else {
        tempActiveProject = state.projectId ? state.projectId : 0;
      }
      const { newProjects, projectId } = createNewProjectList(
        openedList,
        state.projectId,
        state.activeProjectId
      );
      return {
        ...state,
        projects: [...state.projects, ...newProjects],
        projectId,
        activeProjectId: tempActiveProject,
      };
    }

    case types.DUPLICATE_PROJECT: {
      // const projectId = state.projectId;
      // const activeProjectId = state.activeProjectId;
      const projects = cloneDeep(state.projects);
      const duplicateProject = projects
        .filter(project => project.projectId === state.activeProjectId)
        .map(project => {
          project.projectId = state.projectId;
          project.leftPanel = CAC_LEFT_PANEL_VIEW_LABEL;
          project.title = `copy of ${project.title}`;
          project.pid = 0;
          return project;
        });
      const { newProjects, projectId, activeProjectId } = createNewProjectList(
        duplicateProject,
        state.projectId,
        state.activeProjectId
      );
      return {
        ...state,
        projects: [...state.projects, ...newProjects],
        projectId,
        activeProjectId,
      };
    }

    case types.CAC_CLOSE_PROJECT: {
      // const activeProjectId = state.activeProjectId;
      let projects = cloneDeep(state.projects);
      const closeProjectIndex = projects.findIndex(
        item => item.projectId === state.activeProjectId
      );
      projects.splice(closeProjectIndex, 1);
      let newActiveProjectId = null;
      let tempProjectId;
      let tempActiveProjectId;
      if (projects.length > 0) {
        const projectIndex = state.projects.findIndex(
          item => item.projectId === state.activeProjectId
        );
        if (state.activeProjectId === state.projects[0].projectId) {
          newActiveProjectId = state.projects[projectIndex + 1].projectId;
        } else if (
          state.projects[CAC_MAXIMUM_PROJECT_COUNT - 1] &&
          state.activeProjectId ===
            state.projects[CAC_MAXIMUM_PROJECT_COUNT - 1].projectId
        ) {
          newActiveProjectId = state.projects[projectIndex - 1].projectId;
        } else {
          newActiveProjectId = state.projects[projectIndex - 1].projectId;
        }
      } else {
        const newProject = NEW_PROJECT_MINIMUM_DATA;
        if (isEmpty(newProject.study)) {
          newProject.study = action.initialStudy;
        }
        const {
          newProjects,
          projectId,
          activeProjectId,
        } = createNewProjectList(
          [newProject],
          state.projectId,
          state.activeProjectId
        );
        tempActiveProjectId = activeProjectId;
        tempProjectId = projectId;
        projects = newProjects;
      }
      return {
        ...state,
        projects,
        activeProjectId:
          newActiveProjectId !== null
            ? newActiveProjectId
            : tempActiveProjectId,
        projectId: tempProjectId || state.projectId,
      };
    }

    case types.SHOW_HIDE_DATAPOINT: {
      const reduxState = cloneDeep(state.projects);
      const indexVal = action.index;
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.isProjectSaved = false;
          if (action.gridType === 'col') {
            project.columns[indexVal].isShow = !project.columns[indexVal]
              .isShow;
          }
          if (action.gridType === 'row') {
            project.rows[indexVal].isShow = !project.rows[indexVal].isShow;
          }
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }
    case types.CAC_CORR_SWITCH_DATA: {
      const activeProjectId = cloneDeep(state.activeProjectId);
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === activeProjectId) {
          const selectedTabIndex = project.selectedTabIndex;
          if (selectedTabIndex === 0) {
            project.corrMapView = !project.corrMapView;
          }
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CAC_CLUSTER_SWITCH_DATA: {
      const activeProjectId = cloneDeep(state.activeProjectId);
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === activeProjectId) {
          const selectedTabIndex = project.selectedTabIndex;
          if (selectedTabIndex === 1) {
            project.clusterMapView = !project.clusterMapView;
          }
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CAC_UPDATE_PROJECT_STUDY: {
      const { selectedStudy, activeProjectId } = action;
      const updatedWeightType = cloneDeep(action.updatedWeightType);
      const reduxState = cloneDeep(state.projects);
      if (!isEmpty(updatedWeightType) && updatedWeightType.dv === undefined) {
        updatedWeightType.dv = DV_DEFAULT_VALUE;
      }
      const projects = reduxState.map(project => {
        if (project.projectId === activeProjectId) {
          project.study = selectedStudy;
          project.weightTypes = updatedWeightType;
          project.isProjectSaved = false;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CAC_HANDLE_TAB_SELECT: {
      const activeProjectId = cloneDeep(state.activeProjectId);
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === activeProjectId) {
          project.selectedTabIndex = action.tabIndex;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CAC_UPDATE_PROJECT_WEIGHT_TYPES: {
      const { activeProjectId } = action;
      const updatedWeightType = cloneDeep(action.updatedWeightType);
      const reduxState = cloneDeep(state.projects);
      if (!isEmpty(updatedWeightType) && updatedWeightType.dv === undefined) {
        updatedWeightType.dv = DV_DEFAULT_VALUE;
      }
      const projects = reduxState.map(project => {
        if (project.projectId === activeProjectId) {
          project.weightTypes = updatedWeightType;
          project.isProjectSaved = false;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    /** this code has to be reviewed again, added by nikhil */
    case types.GET_CAC_AUTOCODE_SAMPLE_WEIGHTED: {
      // Required Parameters: payload, targetGrid, expressionList, selectedNames
      // Optional Parameters: sourceGrid, gridData, titlePrefix, originalNames
      const keyType = `${action.targetGrid}Data`;
      let gridData = [];
      const oldProductNo = action.oldProductNo && action.oldProductNo;
      if (
        action.gridData ||
        (oldProductNo && oldProductNo !== action.productNo)
      ) {
        gridData = action.gridData ? action.gridData : [];
      } else if (state[keyType]) {
        gridData = state[keyType];
      }
      const titlePrefix = action.titlePrefix ? action.titlePrefix : '';

      const keywordArr = gridData.map(elems => {
        return elems.keyword.trim();
      });
      const titleArr = gridData.map(elems => {
        return elems.title.trim().toUpperCase();
      });
      const draggedItems = [];
      action.payload.forEach((selectedEntry, index) => {
        let title = '';
        if (
          action.sourceGrid !== 'FunctionBox' &&
          action.targetGrid !== 'FunctionBoxCountDataGrid'
        ) {
          title = `${titlePrefix.toUpperCase()}${action.selectedNames[
            index
          ].toUpperCase()}`;
        }
        if (action.targetGrid === 'FunctionBoxCountDataGrid') {
          title = titlePrefix
            ? `${titlePrefix.toUpperCase()}${action.selectedNames[
                index
              ].toUpperCase()}`
            : '';
        }
        if (action.sourceGrid === 'FunctionBox') {
          title = action.selectedNames[index].toUpperCase();
        }
        let originalTitle = title;
        if (action.originalNames && action.originalNames.length > 0) {
          originalTitle = action.originalNames[index];
        } else if (
          action.sourceGrid !== 'ColumnsDataGrid' &&
          action.sourceGrid !== 'RowsDataGrid' &&
          action.sourceGrid !== 'BasesDataGrid' &&
          action.sourceGrid !== 'ScratchDataGrid' &&
          action.sourceGrid !== 'ExpressionCodingBox' &&
          action.sourceGrid !== 'StandardBasesDataGrid' &&
          action.sourceGrid !== 'FunctionBox'
        ) {
          originalTitle = CrosstabUtils.DEFAULT_GRID_CELL_LABEL;
        }
        const weighted =
          selectedEntry && selectedEntry.weighted
            ? Number(selectedEntry.weighted)
            : '';
        const updatedWeighted =
          action.targetGrid === 'FunctionBoxCommonDataGrid' ||
          action.targetGrid === 'FunctionBoxCountDataGrid'
            ? CrosstabUtils.smartRoundOff(weighted * 1000)
            : CrosstabUtils.smartRoundOff(weighted);

        if (keyType === 'StandardBasesDataGridData') {
          draggedItems.push({
            // id: uuid(),
            sample:
              selectedEntry && selectedEntry.intab ? selectedEntry.intab : '',
            keyword: action.expressionList[index],
            weighted: updatedWeighted === 0 ? '' : updatedWeighted,
            title,
            originalTitle,
            isShow: true,
            isPassive: false,
          });
        } else if (
          keywordArr.indexOf(action.expressionList[index].trim()) === -1 ||
          titleArr.indexOf(title.trim()) === -1 ||
          action.weightChange
        ) {
          draggedItems.push({
            // id: uuid(),
            sample:
              selectedEntry && selectedEntry.intab ? selectedEntry.intab : '',
            keyword: action.expressionList[index],
            weighted: updatedWeighted === 0 ? '' : updatedWeighted,
            title,
            originalTitle,
            isShow: true,
            isPassive: false,
          });
        }
      });
      let finalData = [];
      if (
        keyType === 'StandardBasesDataGridData' ||
        action.weightChange ||
        keyType === 'BasesDataGridData'
      ) {
        finalData = [...draggedItems];
      } else {
        finalData = [...gridData, ...draggedItems];
      }
      let cacKeyType = '';
      if (keyType === 'ColumnsDataGridData') {
        cacKeyType = 'columns';
      } else if (keyType === 'RowsDataGridData') {
        cacKeyType = 'rows';
      } else if (keyType === 'BasesDataGridData') {
        cacKeyType = 'base';
      }

      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === state.activeProjectId) {
          project.isProjectSaved = false;
          project[cacKeyType] = [...finalData];
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    /** this code has to be reviewed again, added by nikhil */
    case types.GET_CAC_AUTOCODE_SAMPLE_WEIGHTED_DATA: {
      const keyType = `${action.targetGrid}Data`;
      const gridData = action.gridData ? action.gridData : [];
      const titlePrefix = action.titlePrefix ? action.titlePrefix : '';

      const keywordArr = gridData.map(elems => {
        return elems.keyword;
      });
      const titleArr = gridData.map(elems => {
        return elems.title.trim().toUpperCase();
      });
      const draggedItems = [];
      action.payload.forEach((selectedEntry, index) => {
        const title = `${titlePrefix.toUpperCase()}${action.selectedNames[
          index
        ].toUpperCase()}`;
        let originalTitle = title;
        // const isLabelUpdated = action.isLabelUpdated
        //   ? action.isLabelUpdated[index]
        //   : undefined;
        // selectedKPIsTitle[action.expressionList[index]] = title;
        // const rectype = action.recTypes && action.recTypes[index];
        if (action.originalNames && action.originalNames.length > 0) {
          originalTitle = action.originalNames[index];
        } else if (
          action.sourceGrid !== 'ColumnsDataGrid' &&
          action.sourceGrid !== 'RowsDataGrid' &&
          action.sourceGrid !== 'BasesDataGrid' &&
          action.sourceGrid !== 'ScratchDataGrid' &&
          action.sourceGrid !== 'ExpressionCodingBox'
        ) {
          originalTitle = CrosstabUtils.DEFAULT_GRID_CELL_LABEL;
        }
        const weighted =
          selectedEntry && selectedEntry.weighted
            ? Number(selectedEntry.weighted)
            : '';
        const updatedWeighted =
          action.targetGrid === 'FunctionBoxCommonDataGrid' ||
          action.targetGrid === 'FunctionBoxCountDataGrid'
            ? CrosstabUtils.smartRoundOff(weighted * 1000)
            : CrosstabUtils.smartRoundOff(weighted);
        if (
          keywordArr.indexOf(action.expressionList[index]) === -1 ||
          titleArr.indexOf(title.trim()) === -1
        ) {
          draggedItems.push({
            // id: uuid(),
            sample:
              selectedEntry && selectedEntry.intab ? selectedEntry.intab : '',
            keyword: action.expressionList[index],
            weighted: updatedWeighted === 0 ? '' : updatedWeighted,
            title,
            originalTitle,
            isShow: true,
            isPassive: false,
          });
        }
      });
      let cacKeyType = '';
      if (keyType === 'ColumnsDataGridData') {
        cacKeyType = 'columns';
      } else if (keyType === 'RowsDataGridData') {
        cacKeyType = 'rows';
      } else if (keyType === 'BasesDataGridData') {
        cacKeyType = 'base';
      }

      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === state.activeProjectId) {
          project.isProjectSaved = false;
          if (keyType === 'BasesDataGridData') {
            project[cacKeyType] = [...draggedItems];
          } else {
            project[cacKeyType] = [...project[cacKeyType], ...draggedItems];
          }
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CLEAR_CAC_SAMPLE_WEIGHTED: {
      const keyType = `${action.targetGrid}Data`;
      // const recycleElements = state.RecycleGridData
      //   ? [...state.RecycleGridData]
      //   : [];
      const titleHeaderList = cloneDeep(state.crosstabTitleHeaderList);
      // const selectedGridData = state[keyType] ? [...state[keyType]] : [];
      if (titleHeaderList && titleHeaderList[action.targetGrid]) {
        titleHeaderList[action.targetGrid] = [];
      }

      let cacKeyType = '';
      if (keyType === 'ColumnsDataGridData') {
        cacKeyType = 'columns';
      } else if (keyType === 'RowsDataGridData') {
        cacKeyType = 'rows';
      } else if (keyType === 'BasesDataGridData') {
        cacKeyType = 'base';
      }

      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === state.activeProjectId) {
          project.isProjectSaved = false;
          if (keyType === 'BasesDataGridData') {
            project[cacKeyType] = [
              {
                keyword: 'StudyUniverseKey',
                title: 'STUDY UNIVERSE',
                originalTitle: 'STUDY UNIVERSE',
              },
            ];
          } else {
            project[cacKeyType] = [];
          }
        }
        return project;
      });

      return {
        ...state,
        projects: [...projects],
        // RecycleGridData: [...selectedGridData, ...recycleElements],
        // crosstabTitleHeaderList: titleHeaderList,
      };
    }

    case types.UPDATE_CAC_SAMPLE_WEIGHTED: {
      const keyType = `${action.targetGrid}Data`;
      const keywordArr = [];
      const gridData = [];
      const titleArr = [];
      action.gridData.forEach(elems => {
        if (
          keywordArr.indexOf(elems.keyword.trim()) === -1 ||
          titleArr.indexOf(elems.title.trim()) === -1
        ) {
          keywordArr.push(elems.keyword.trim());
          titleArr.push(elems.title.trim());
          gridData.push(elems);
        }
      });

      let cacKeyType = '';
      if (keyType === 'ColumnsDataGridData') {
        cacKeyType = 'columns';
      } else if (keyType === 'RowsDataGridData') {
        cacKeyType = 'rows';
      } else if (keyType === 'BasesDataGridData') {
        cacKeyType = 'base';
      } else if (keyType === 'RecycleGridData') {
        cacKeyType = 'RecycleGridData';
      }

      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === state.activeProjectId) {
          project.isProjectSaved = false;
          project[cacKeyType] = gridData;
        }
        return project;
      });

      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CAC_CLUST_UPDATE_SEGMENT_COUNT: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.clusterSegmentCount = action.segmentCount;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CAC_CLUST_SELECTED_CLUSTER: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === action.activeProjectId) {
          project.selectedCluster = action.selectedCluster;
          project.clusterSegmentCount = action.segmentCount;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CLUSTER_PROJECT_DETAILS: {
      const reduxState = cloneDeep(state.projects);
      const activeProject = state.activeProjectId;
      if (action.payload.status === 400 || action.payload.status === 500) {
        const status = action.payload.status;
        const projects = reduxState.map(project => {
          if (activeProject === project.projectId) {
            project.clusterResponse = {};
            project.clusterResponse.errMsg = status === 400 ? action.payload.message : CLUSTER_ERROR_MESSAGE;
          }
          return project;
        });
        return {
          ...state,
          projects: [...projects],
        };
      }
      const segmentCount = action.payload.solutions.find(item => item.optimal)
       .segmentCount;
      const projects = reduxState.map(project => {
        if (activeProject === project.projectId) {
          action.payload.solutions = sortBy(action.payload.solutions, [
            'variance',
          ]);
          project.clusterResponse = action.payload;
          project.selectedCluster = segmentCount - 2;
          project.clusterSegmentCount = segmentCount;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      }; 
    }

    case types.CAC_ADD_DEFAULT_BASE: {
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === state.activeProjectId) {
          project.base = [
            {
              keyword: 'StudyUniverseKey',
              title: 'STUDY UNIVERSE',
              originalTitle: 'STUDY UNIVERSE',
            },
          ];
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.HANDLE_CLUSTER_BY_SWITCH: {
      const activeProjectId = cloneDeep(state.activeProjectId);
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === activeProjectId) {
          project.isProjectSaved = false;
          project.clusterBy = action.val;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CORR_TABLE_TAB_SELECT: {
      const { table, module } = action.payload;
      const activeProjectId = cloneDeep(state.activeProjectId);
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === activeProjectId) {
          project.activeTable[module] = table;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.CORR_TABLE_SORT_DATA: {
      const { sortObj, tableType, module } = action.payload;
      const activeProjectId = cloneDeep(state.activeProjectId);
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === activeProjectId) {
          const table = project.activeTable[tableType];
          project.sortData[module][table] = sortObj;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.EDIT_CLUSTER_SEGMENT_NAME: {
      const { newSegmentName, index } = action;
      const activeProjectId = cloneDeep(state.activeProjectId);
      const reduxState = cloneDeep(state.projects);
      const projects = reduxState.map(project => {
        if (project.projectId === activeProjectId) {
          const clusterSegmentCount = cloneDeep(project.clusterSegmentCount);
          const selectedSolution = project.clusterResponse.solutions.findIndex(
            item => item.segmentCount === clusterSegmentCount
          );
          project.clusterResponse.solutions[selectedSolution].segments[
            index
          ].segmentName = newSegmentName;
        }
        return project;
      });
      return {
        ...state,
        projects: [...projects],
      };
    }

    case types.EXPORT_CLUSTER_AND_CORRESPONDENCE: {
      const link = document.createElement('a');
      document.body.appendChild(link);
      if (action.payload.url) {
        link.target = '_blank'
        link.href = action.payload.url;
      } else {
        link.href = '#';
      }
      link.click();
      return state;
    }

    default:
      return state;
  }
}
